export { default } from './GraphQLConfigDiff';
